function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.5 4.25L13.5 2.25L10.5 0.25V1.75H4.07143C1.82281 1.75 0 3.57299 0 5.82169C0 6.89042 0.412382 7.86395 1.08578 8.59001L1.81898 7.90999C1.31031 7.36154 1 6.62842 1 5.82169C1 4.12521 2.37516 2.75 4.07143 2.75H10.5V4.25Z",
  fill: "#BD3030"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M2.5 10.25L5.5 8.25L5.5 9.75L11.9286 9.75C13.6248 9.75 15 8.37479 15 6.67831C15 5.87158 14.6897 5.13846 14.181 4.59001L14.9142 3.90999C15.5876 4.63605 16 5.60958 16 6.67831C16 8.92701 14.1772 10.75 11.9286 10.75L5.5 10.75V12.25L2.5 10.25Z",
  fill: "#BD3030"
});

var SvgIconRepeatContext = function SvgIconRepeatContext(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconRepeatContext, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_repeat_context.28d69ad1.svg";
export { ForwardRef as ReactComponent };